// extracted by mini-css-extract-plugin
export default {"grid":"ListingDetails_grid__Kgswg","details":"ListingDetails_details__D1zEi"};